// @ts-nocheck
/* eslint-disable */
import SceneFeature from "../feature";

export default class SceneControl extends SceneFeature {
	/**
	 * Informace ohledne entity ve scene.
	 *
	 * @return {Object}
	 */
	get featureInfo() {
		return {
			name: "SceneControl",
			type: "control"
		};
	}
}
